import React from "react";
import PropTypes from "prop-types";
import { Label } from "@conserveit/blocks";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import Moment from "moment";
import DynamicFormComponent from "./DynamicFormComponent";
import Validator from "./Validator";

@connect(
  (state) => ({
    isFormDisabled: state.reportGenerator.isFormDisabled,
  }),
  null,
  null,
  { forwardRef: true }
)
export default class Date extends DynamicFormComponent {
  static propTypes = {
    isFormDisabled: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      startDate: Moment(),
      isFormValid: true,
    };
  }

  // react-datepicker works with Date objects; state is kept as moment.
  handleDateChange = (date) => {
    this.setState({
      startDate: date && Moment(date),
      isFormValid: true,
    });
  };

  validate = () => {
    if (!this.state.startDate) {
      this.setState({ isFormValid: false });
      return false;
    }
    return true;
  };

  getSelectedValues = () => {
    return {
      startDate: this.state.startDate.format("YYYY-MM-DD"),
    };
  };

  render() {
    require("react-datepicker/dist/react-datepicker.css");

    const { startDate } = this.state;

    return (
      <div>
        <Label>Date</Label>
        <div>
          <Validator
            isValid={this.state.isFormValid}
            errMsg="Date range is required"
          >
            <DatePicker
              selected={startDate && startDate.toDate()}
              todayButton="Select today"
              dateFormat="dd MMM yyyy"
              isClearable
              disabled={this.props.isFormDisabled}
              onChange={this.handleDateChange}
              maxDate={Moment().toDate()}
            />
          </Validator>
        </div>
      </div>
    );
  }
}
